import { render, staticRenderFns } from "./SubwebsiteDialog.vue?vue&type=template&id=15a02a2d&"
import script from "./SubwebsiteDialog.vue?vue&type=script&lang=ts&"
export * from "./SubwebsiteDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports